(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["afterpay-message"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('afterpay-message')) {
    class AfterpayMessage extends HTMLElement {
      connectedCallback() {
        this.details = this.closest('.product-details, product-details, .product-information') || document;
        this.observer = new MutationObserver(() => this.update());
        const price = this.details.querySelector('product-price');
        if (price) this.observer.observe(price, { childList: true, subtree: true, characterData: true });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      update() {
        const priceEl = this.details.querySelector('product-price .price, product-price');
        if (!priceEl) return;
        const match = priceEl.textContent.replace(/,/g, '').match(/(\d+(?:\.\d{1,2})?)/);
        if (!match) return;
        const cents = Math.round(parseFloat(match[1]) * 100);
        const min = Number(this.dataset.min);
        const max = Number(this.dataset.max);
        this.hidden = cents < min || cents > max;
        const amount = this.querySelector('.afterpay-message__amount');
        if (!amount) return;
        const formatter = new Intl.NumberFormat('en-AU', { style: 'currency', currency: this.dataset.currency || 'AUD' });
        amount.textContent = formatter.format(Math.floor(cents / 4) / 100);
      }
    }

    customElements.define('afterpay-message', AfterpayMessage);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["size-guide"] && !Shopify.designMode) return;
  try {
    class SizeGuide extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.input = this.querySelector('[data-finder-input]');
      this.result = this.querySelector('[data-finder-result]');
      this.label = this.querySelector('[data-finder-label]');
      this.unit = 'cm';

      this.querySelector('[data-open]').addEventListener('click', () => this.dialog.showModal());
      this.querySelectorAll('[data-close]').forEach((button) => {
        button.addEventListener('click', () => this.dialog.close());
      });
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
      this.querySelectorAll('[data-unit]').forEach((button) => {
        button.addEventListener('click', () => this.setUnit(button.dataset.unit));
      });
      this.input.addEventListener('input', () => this.find());
      this.setUnit('cm');
    }

    convert(text) {
      if (this.unit === 'cm') return text;
      return text.replace(/\d+(\.\d+)?/g, (n) => String(Math.round((parseFloat(n) / 2.54) * 10) / 10));
    }

    setUnit(unit) {
      this.unit = unit;
      this.querySelectorAll('[data-unit]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.unit === unit));
      });
      this.querySelectorAll('td[data-cm]').forEach((cell) => {
        cell.textContent = this.convert(cell.dataset.cm);
      });
      this.querySelectorAll('th[data-measure]').forEach((cell) => {
        cell.textContent = cell.dataset.label + ' (' + unit + ')';
      });
      const measure = this.querySelector('th[data-measure]');
      if (measure) this.label.textContent = 'Enter your ' + measure.dataset.label.toLowerCase() + ' (' + unit + ')';
      this.find();
    }

    find() {
      const firstTable = this.querySelector('table');
      const rows = firstTable ? firstTable.querySelectorAll('tbody tr') : [];
      this.querySelectorAll('tbody tr').forEach((row) => row.classList.remove('size-guide__row--match'));
      this.result.textContent = '';

      const value = parseFloat(this.input.value);
      if (Number.isNaN(value) || value <= 0) return;

      const cm = this.unit === 'in' ? value * 2.54 : value;
      let best = null;
      let bestDistance = Infinity;

      rows.forEach((row) => {
        const cell = row.querySelector('td[data-cm]');
        if (!cell) return;
        const numbers = (cell.dataset.cm.match(/\d+(\.\d+)?/g) || []).map(Number);
        if (!numbers.length) return;
        const min = Math.min(...numbers);
        const max = Math.max(...numbers);
        const distance = cm < min ? min - cm : cm > max ? cm - max : 0;
        if (distance < bestDistance) {
          bestDistance = distance;
          best = row;
        }
      });

      if (best) {
        best.classList.add('size-guide__row--match');
        const size = best.querySelector('th').textContent;
        this.result.innerHTML = '';
        this.result.append('Suggested size: ' + size);
        const hint = document.createElement('small');
        hint.textContent = 'Between two sizes? Choose the larger for a relaxed fit or the smaller for a closer fit.';
        this.result.append(hint);
      }
    }
  }

  if (!customElements.get('size-guide')) customElements.define('size-guide', SizeGuide);
  } catch(e) { console.error(e); }
})();

})();
